import Icon, { ICONSIZE } from '../../../../../../../presentation/components/Icon';
import houseTransmissionIcon from '../../../../../../assets/icons/png/3x/icn-datenuebermittlung@3x-schwarz.png';
import checkmarkIcon from '../../../../../../assets/icons/png/3x/circle-check-info@3x.png';
import TableEntry from '../../TableEntry';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'tools/hooks/useMediaQuery';

const WirelessConsumptionMetering = () => {
  const isAboveXXS = useMediaQuery('(min-width: 376px)');
  const { t } = useTranslation();

  return (
    <TableEntry
      leftValues={[
        t('pageSummaryBasicServicesSectionLabelWirelessConsumptionMeteringTitle'),
        t('pageSummaryBasicServicesSectionLabelWirelessConsumptionMeteringContent')
      ]}
      startElement={
        <Icon
          iconSrc={houseTransmissionIcon}
          size={ICONSIZE.medium}
          alt="wireless consumption metering icon"
        />
      }
      endElement={
        <Icon iconSrc={checkmarkIcon} size={ICONSIZE.small} centered alt="checkmark icon" />
      }
      additionalClassNames={isAboveXXS ? '' : 'px-0'}
    />
  );
};

export default WirelessConsumptionMetering;
